import React from "react";
import { connect } from "react-redux";
import FinalPayTable from "./components/FinalPayTable";

const FinalPays = ({filters}) => {
	
	return (
	    <div>
	      <div className="mt-5 grid h-full grid-cols-1 gap-4">
      		
	      	<FinalPayTable/>
	      	
	      </div>
	    </div>
    );
};

const mapStateToProps = (state) => ({
  filters: state.salaryAddition.salaryAdditionList?.filters,
});

const mapDispatchToProps = (dispatch) => ({

});

export default connect(mapStateToProps, mapDispatchToProps)(FinalPays);